import { IDTOPresumedReturn, ISimpleNational, ITaxData } from "../model";

export function taxDataDTOPresumed(taxData: ITaxData): IDTOPresumedReturn {
  const valueSystem = {
    1: "Sebrae",
    2: "Senai",
    3: "SESI",
  };
  return {
    ...taxDataDTOSimple(taxData),
    workAccidentInsurance: +taxData?.taxesDataItens?.workAccidentInsurance,
    educationSalary: +taxData?.taxesDataItens?.educationSalary,
    weeklyPaidRest: +taxData?.taxesDataItens?.weeklyPaidRest,
    holidayProportional: +taxData?.taxesDataItens?.holidayProportional,
    system: valueSystem[+taxData?.taxesDataItens?.system] as "Sebrae" | "Senai" | "Sesi",
    proportionalThirteenthSalary: +taxData?.taxesDataItens?.proportionalThirteenthSalary,
  };
}

function replaceNumber(value) {
  return value?.replace(',', '.')
}

export function taxDataDTOSimple(taxData: ITaxData): ISimpleNational {
  return {
    name: taxData?.name,
    vacation: +replaceNumber(taxData?.taxesDataItens?.vacation),
    FGTS: +replaceNumber(taxData?.taxesDataItens?.fgts),
    oneThirdOnVacations: +replaceNumber(taxData?.taxesDataItens?.thirdVacation),
    thirteenFirstSalary: +replaceNumber(taxData?.taxesDataItens?.thirteenth),
    monthlyProvision: +replaceNumber(taxData?.taxesDataItens?.monthlyProvision),
    INSS: +replaceNumber(taxData?.taxesDataItens?.inss),
  };
}

export function DTOGetTax(taxData: IDTOPresumedReturn): ITaxData {
  const valueSystem = {
    Sebrae: 1,
    Senai: 2,
    SESI: 3,
  };
  return {
    name: taxData.name,
    taxesDataItens: {
      educationSalary: taxData?.educationSalary,
      fgts: taxData?.FGTS,
      inss: taxData?.INSS,
      monthlyProvision: taxData?.monthlyProvision,
      vacation: taxData?.vacation,
      thirteenth: taxData?.thirteenFirstSalary,
      thirdVacation: taxData?.oneThirdOnVacations,
      workAccidentInsurance: taxData?.workAccidentInsurance,
      weeklyPaidRest: taxData?.weeklyPaidRest,
      system: valueSystem[taxData?.system],
      proportionalThirteenthSalary: taxData?.proportionalThirteenthSalary,
      holidayProportional: taxData?.holidayProportional,
    },
  };
}
